import { useRef, useState } from "react";
import { Trash2 } from "lucide-react";
import type { Appointment } from "../../shared/domain";
import { api } from "../api";
import { useStore } from "../store";
import { ErrorText } from "./ui";

// Shared confirmation, mutation guard and Undo handoff for forms and details.
export function AppointmentDelete({
  appointment,
  onClose,
  onDelete,
  disabled = false,
}: {
  appointment: Appointment;
  onClose: () => void;
  onDelete?: (a: Appointment, until: number) => void;
  disabled?: boolean;
}) {
  const { offline, refresh } = useStore();
  const [confirm, setConfirm] = useState(false),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const pending = useRef(false);
  async function remove() {
    if (offline || disabled || pending.current) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      const r = await api<{ undoUntil: number }>(
        "/appointments/" + appointment.id,
        "DELETE",
        {},
      );
      await refresh();
      onDelete?.(appointment, r.undoUntil);
      onClose();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      pending.current = false;
      setBusy(false);
    }
  }
  return (
    <div>
      {confirm ? (
        <div className="delete-confirm">
          <p>Delete this appointment? You can undo for 10 seconds.</p>
          <button
            type="button"
            className="danger"
            disabled={offline || disabled || busy}
            onClick={() => void remove()}
          >
            {busy ? "Deleting…" : "Delete appointment"}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={() => setConfirm(false)}
          >
            Keep appointment
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="text-button danger"
          disabled={offline || disabled}
          onClick={() => setConfirm(true)}
        >
          <Trash2 size={16} />
          Delete appointment
        </button>
      )}
      <ErrorText text={error} />
    </div>
  );
}
